const EvaluationEvent = {
  CHART_SELECTED: 'evaluationChartSelected',
  INITIALIZED: 'evaluationInitialized',
};

export default EvaluationEvent;
